import { createContext, useContext, useEffect } from 'react';

export type CmsDecision = {
  title: string;
  message: string;
  choices: { value: string; label: string; danger?: boolean }[];
};
type Interaction = {
  ask: (decision: CmsDecision) => Promise<string | null>;
  setPending: (key: string, pending: boolean) => void;
  pendingCount: number;
  pendingLabels: string[];
  busyCount: number;
  setBusy: (key: string, busy: boolean) => void;
};
export const CmsInteractionContext = createContext<Interaction>({
  ask: () => Promise.resolve(null),
  setPending: () => {},
  pendingCount: 0,
  pendingLabels: [],
  busyCount: 0,
  setBusy: () => {},
});
export function useCmsInteractions() {
  return useContext(CmsInteractionContext);
}
export function useCmsPendingForm(key: string, pending: boolean): void {
  const { setPending } = useCmsInteractions();
  useEffect(() => {
    setPending(key, pending);
    return () => setPending(key, false);
  }, [key, pending, setPending]);
}
export function useCmsBusyOperation(key: string, busy: boolean): void {
  const { setBusy } = useCmsInteractions();
  useEffect(() => {
    setBusy(key, busy);
    return () => setBusy(key, false);
  }, [key, busy, setBusy]);
}
